import axios from "axios";
import APILinks from "@/links/links";

export default {
  login(loginData) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(APILinks.LOGIN(), loginData, {
      headers: headers,
    });
  },
  tokenRefresh() {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(
      APILinks.TOKEN_REFRESH(),
      { refresh_token: localStorage.getItem("refresh_token") },
      { headers: headers }
    );
  },
  /** Forgot Password */
  checkEmail(email) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(APILinks.CHECK_EMAIL(), { email: email }, { headers: headers });
  },
  checkUsername(username) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(APILinks.CHECK_USERNAME(), { username: username }, { headers: headers });
  },
  checkVerificationCode(verificationCode) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(
      APILinks.CHECK_VERIFICATION_CODE(),
      { verificationCode: verificationCode },
      { headers: headers }
    );
  },
  setPassword(verificationCode, password) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(
      APILinks.SET_PASSWORD(),
      {
        verificationCode: verificationCode,
        plainPassword: password,
      },
      { headers: headers }
    );
  },
};
